export const tableHeader = (t) => [
  { id: "entity_name", label: t('company:complianceProgram.dashboard.table.name'),  type: "name-description", nameKey: 'entity_name', descriptionKey: 'entity_description', sortable: true },
  { id: "entity_type", label: t('company:complianceProgram.dashboard.table.type'), type: "type-entity" , sortable: true },
  { id: "progresso", label: t('company:complianceProgram.dashboard.table.progress'), type: "progress", sortable: true },
];
